module.exports = __webpack_public_path__ + "img/spinning-circles.90e83534.svg";